const _excluded = ["className", "children", "empty", "emptyMsg", "loading", "loadingMsg", "loadingOrEmptyBg", "error", "onRefresh"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import React from 'react';
import cn from 'classnames';
import { Card, Typography, Button } from 'seagull';
import styles from "./GraphWidgetBottomCard.module.scss";
/** Renders a card for the 2nd row of a graph widget. */
export default function GraphWidgetBottomCard(props) {
  const {
      className,
      children,
      empty,
      emptyMsg,
      loading,
      loadingMsg,
      loadingOrEmptyBg,
      error,
      onRefresh
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  return /*#__PURE__*/React.createElement(Card, _extends({}, rest, {
    className: cn(styles.root, className)
  }), error ? /*#__PURE__*/React.createElement("div", {
    className: styles.error,
    "data-testid": props['data-testid'] && "".concat(props['data-testid'], "-error")
  }, errorIcon, /*#__PURE__*/React.createElement(Typography, null, "Something went wrong. Try to refresh the data."), /*#__PURE__*/React.createElement(Button, {
    "data-testid": props['data-testid'] && "".concat(props['data-testid'], "-refresh"),
    onClick: onRefresh
  }, "Refresh")) : loading || empty ? /*#__PURE__*/React.createElement("div", {
    className: styles.loading,
    "data-testid": props['data-testid'] && "".concat(props['data-testid'], "-").concat(loading ? 'loading' : 'empty')
  }, loadingOrEmptyBg && loadingOrEmptyBg(), loading ? /*#__PURE__*/React.createElement(Typography, {
    className: styles.loadingText
  }, loadingMsg) : emptyMsg != null ? /*#__PURE__*/React.createElement(Typography, {
    className: styles.loadingText
  }, emptyMsg) : /*#__PURE__*/React.createElement(React.Fragment, null, loadingMsg)) : children);
}
const errorIcon = /*#__PURE__*/React.createElement("svg", {
  width: "145",
  height: "144",
  viewBox: "0 0 145 144",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter0_dd_181_18775)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M104.768 38.1234C105.834 36.8972 107.38 36.1931 109.004 36.1931H120.128C122.337 36.1931 124.128 37.9839 124.128 40.1931V115.335H106.112L104.535 39.3685L104.768 38.3647V38.1234Z",
  fill: "url(#paint0_linear_181_18775)"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter1_dd_181_18775)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M77.0116 58.6328C77.9286 57.5609 79.2687 56.9438 80.6793 56.9438H92.1376C94.3467 56.9438 96.1376 58.7347 96.1376 60.9438V115.335H78.1215L76.7783 59.3567L77.0116 58.6328Z",
  fill: "url(#paint1_linear_181_18775)"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter2_dd_181_18775)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M49.0223 73.5927C49.9393 72.5208 51.2794 71.9037 52.6901 71.9037H64.1483C66.3575 71.9037 68.1483 73.6945 68.1483 75.9037V115.335H50.1322L48.7891 74.3166L49.0223 73.5927Z",
  fill: "url(#paint2_linear_181_18775)"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#filter3_dd_181_18775)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M21.033 83.7267C21.9501 82.6548 23.2901 82.0377 24.7008 82.0377H36.1591C38.3682 82.0377 40.1591 83.8286 40.1591 86.0377V115.335H22.143L20.7998 84.4506L21.033 83.7267Z",
  fill: "url(#paint3_linear_181_18775)"
})), /*#__PURE__*/React.createElement("path", {
  d: "M104.535 41.1583C104.535 38.9491 106.326 37.1583 108.535 37.1583H119.195C121.404 37.1583 123.195 38.9492 123.195 41.1583V115.335H104.535V41.1583Z",
  fill: "#FCFCFD"
}), /*#__PURE__*/React.createElement("path", {
  d: "M76.5459 61.9091C76.5459 59.7 78.3368 57.9091 80.5459 57.9091H91.2054C93.4146 57.9091 95.2054 59.6999 95.2054 61.9091V115.336H76.5459V61.9091Z",
  fill: "#FCFCFD"
}), /*#__PURE__*/React.createElement("path", {
  d: "M48.5557 76.8688C48.5557 74.6597 50.3465 72.8688 52.5557 72.8688H63.2152C65.4243 72.8688 67.2152 74.6597 67.2152 76.8688V115.335H48.5557V76.8688Z",
  fill: "#FCFCFD"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.5674 87.0029C20.5674 84.7938 22.3582 83.0029 24.5674 83.0029H35.2269C37.436 83.0029 39.2269 84.7938 39.2269 87.0029V115.335H20.5674V87.0029Z",
  fill: "#FCFCFD"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.0039 87.2734C11.0039 87.2734 48.7894 92.3404 83.3095 71.5897C117.83 50.839 123.333 28.9291 123.333 28.9291",
  stroke: "#6942F8",
  strokeWidth: "3",
  strokeLinecap: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M119.218 30.3093L123.627 28.1765L125.583 32.5041",
  stroke: "#6942F8",
  strokeWidth: "3",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11 115.697L131 115.697",
  stroke: "#282863",
  strokeWidth: "2",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter0_dd_181_18775",
  x: "84.5352",
  y: "6.19308",
  width: "59.5928",
  height: "137.142",
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: "0",
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: "-10"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: "10"
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.564323 0 0 0 0 0.513021 0 0 0 0 0.820833 0 0 0 0.04 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_181_18775"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: "8"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: "10"
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.156863 0 0 0 0 0.117647 0 0 0 0 0.352941 0 0 0 0.12 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect1_dropShadow_181_18775",
  result: "effect2_dropShadow_181_18775"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect2_dropShadow_181_18775",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter1_dd_181_18775",
  x: "56.7783",
  y: "26.9438",
  width: "59.3594",
  height: "116.392",
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: "0",
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: "-10"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: "10"
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.564323 0 0 0 0 0.513021 0 0 0 0 0.820833 0 0 0 0.04 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_181_18775"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: "8"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: "10"
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.156863 0 0 0 0 0.117647 0 0 0 0 0.352941 0 0 0 0.12 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect1_dropShadow_181_18775",
  result: "effect2_dropShadow_181_18775"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect2_dropShadow_181_18775",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter2_dd_181_18775",
  x: "28.7891",
  y: "41.9037",
  width: "59.3594",
  height: "101.432",
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: "0",
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: "-10"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: "10"
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.564323 0 0 0 0 0.513021 0 0 0 0 0.820833 0 0 0 0.04 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_181_18775"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: "8"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: "10"
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.156863 0 0 0 0 0.117647 0 0 0 0 0.352941 0 0 0 0.12 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect1_dropShadow_181_18775",
  result: "effect2_dropShadow_181_18775"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect2_dropShadow_181_18775",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "filter3_dd_181_18775",
  x: "0.799805",
  y: "52.0377",
  width: "59.3594",
  height: "91.2977",
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: "0",
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: "-10"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: "10"
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.564323 0 0 0 0 0.513021 0 0 0 0 0.820833 0 0 0 0.04 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_181_18775"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  type: "matrix",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: "8"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: "10"
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  type: "matrix",
  values: "0 0 0 0 0.156863 0 0 0 0 0.117647 0 0 0 0 0.352941 0 0 0 0.12 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in2: "effect1_dropShadow_181_18775",
  result: "effect2_dropShadow_181_18775"
}), /*#__PURE__*/React.createElement("feBlend", {
  mode: "normal",
  in: "SourceGraphic",
  in2: "effect2_dropShadow_181_18775",
  result: "shape"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_181_18775",
  x1: "99.7565",
  y1: "44.69",
  x2: "109.722",
  y2: "62.7707",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#DCE0F4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "0.247812",
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "0.303741",
  stopColor: "#E9ECFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "0.529511",
  stopColor: "#DDE2FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "0.673845",
  stopColor: "#CED6FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "0.740917",
  stopColor: "#C1CAFB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#C2C8EB"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_181_18775",
  x1: "71.7664",
  y1: "63.2129",
  x2: "77.8359",
  y2: "78.1375",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#DCE0F4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "0.247812",
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "0.303741",
  stopColor: "#E9ECFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "0.529511",
  stopColor: "#DDE2FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "0.673845",
  stopColor: "#CED6FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "0.740917",
  stopColor: "#C1CAFB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#C2C8EB"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint2_linear_181_18775",
  x1: "43.7772",
  y1: "78.1727",
  x2: "49.8466",
  y2: "93.0974",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#DCE0F4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "0.247812",
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "0.303741",
  stopColor: "#E9ECFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "0.529511",
  stopColor: "#DDE2FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "0.673845",
  stopColor: "#CED6FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "0.740917",
  stopColor: "#C1CAFB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#C2C8EB"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint3_linear_181_18775",
  x1: "15.7879",
  y1: "88.3068",
  x2: "21.8574",
  y2: "103.231",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#DCE0F4"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "0.247812",
  stopColor: "white"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "0.303741",
  stopColor: "#E9ECFF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "0.529511",
  stopColor: "#DDE2FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "0.673845",
  stopColor: "#CED6FF"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "0.740917",
  stopColor: "#C1CAFB"
}), /*#__PURE__*/React.createElement("stop", {
  offset: "1",
  stopColor: "#C2C8EB"
}))));